import React from "react";
import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { buildWaLink } from "../lib/api";
import Reveal from "./Reveal";

const BG =
  "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const CtaBanner = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="cta-banner"
      className="relative overflow-hidden py-32 md:py-40"
    >
      <div
        className="absolute inset-0 bg-cover bg-center animate-kenburns"
        style={{ backgroundImage: `url(${BG})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0C2230]/85 via-[#0C2230]/55 to-[#0C2230]/30" />

      <div className="relative z-10 mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <Reveal>
          <div className="max-w-2xl">
            <h2 className="font-[Fraunces] text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-5xl md:text-6xl">
              <span className="italic font-light">{t.cta.title.split(" ")[0]}</span>{" "}
              {t.cta.title.split(" ").slice(1).join(" ")}
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-white/85 md:text-lg">
              {t.cta.sub}
            </p>
            <a
              href={buildWaLink(t.waMessages.banner)}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-banner-whatsapp"
              className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#0E9A57] px-8 py-4 text-sm font-semibold text-white shadow-lg transition-all hover:bg-[#0c8a4d] hover:shadow-2xl"
            >
              <MessageCircle className="h-4 w-4" />
              {t.cta.button}
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBanner;
